import React from 'react';
import { Snackbar, Box, Typography, Slide } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const TransitionResult = (props) => {
    return <Slide {...props} direction="down" />;
};

const Toast = ({ message, type = 'success', onClose, duration = 4000 }) => {
    const isSuccess = type === 'success';
    const mainColor = isSuccess ? '#0B6E4F' : '#CC0000'; // Success green / R5 brand red
    const fg = '#050505';
    const bg = 'rgba(255, 255, 255, 0.96)';

    return (
        <Snackbar 
            open={!!message} 
            autoHideDuration={duration} 
            onClose={onClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            TransitionComponent={TransitionResult}
            sx={{ 
                top: { xs: '24px !important', md: '40px !important' }, // Force override
                zIndex: 99999 
            }}
        >
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                backgroundColor: bg,
                backdropFilter: 'blur(10px)',
                borderRadius: '14px',
                pl: 1.25,
                pr: 3,
                py: 1.25,
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.18)',
                border: '1px solid rgba(0, 0, 0, 0.16)',
                borderLeft: `4px solid ${mainColor}`,
                maxWidth: 'min(720px, calc(100vw - 24px))',
            }}>
                {/* Icon Tile */}
                <Box sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '14px',
                    backgroundColor: 'transparent',
                    border: `1px solid ${mainColor}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: mainColor,
                }}>
                    {isSuccess ? <CheckCircleOutlineIcon fontSize="small" /> : <ErrorOutlineIcon fontSize="small" />}
                </Box>

                {/* Message */}
                <Typography sx={{
                    color: fg,
                    fontSize: { xs: '0.92rem', md: '0.95rem' },
                    fontWeight: 700,
                    letterSpacing: '0em',
                    fontFamily: '"JetBrains Mono", monospace',
                    lineHeight: 1.35
                }}>
                    {message}
                </Typography>
            </Box>
        </Snackbar>
    );
};

export default Toast;
